import React from "react"
import ContentLoader from "react-content-loader"

export const LoaderLeft = (props) => (
  <ContentLoader 
    speed={2}
    width={400}
    height={240}
    viewBox="0 0 400 240"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <circle cx="13" cy="12" r="8" /> 
    <rect x="28" y="7" rx="5" ry="5" width="220" height="10" /> 
    <circle cx="13" cy="42" r="8" /> 
    <rect x="28" y="37" rx="5" ry="5" width="220" height="10" /> 
    <circle cx="13" cy="72" r="8" /> 
    <rect x="28" y="67" rx="5" ry="5" width="220" height="10" /> 
    <circle cx="13" cy="102" r="8" /> 
    <rect x="28" y="97" rx="5" ry="5" width="220" height="10" /> 
    <circle cx="13" cy="125" r="8" /> 
    <rect x="28" y="120" rx="5" ry="5" width="220" height="10" /> 
    <circle cx="13" cy="155" r="8" /> 
    <rect x="28" y="150" rx="5" ry="5" width="220" height="10" /> 
    <circle cx="13" cy="185" r="8" /> 
    <rect x="28" y="180" rx="5" ry="5" width="220" height="10" /> 
    <circle cx="13" cy="215" r="8" /> 
    <rect x="28" y="210" rx="5" ry="5" width="220" height="10" />

  </ContentLoader>
)



